export class LayerNameSpace {
  name: string;
  namespace: string;

  constructor(init: Partial<LayerNameSpace>) {
    Object.assign(this, init);
  }
}
